<template>
  <div class="unauthorized">
    <h5>Do te vsebine nimate dostopa!</h5>
  </div>
</template>

<script>
export default {
  name: 'Unauthorized'
}</script>